













import { KwaiPlayerControlsVolume, useVideoProperties } from '@ks/player';
import { defineComponent, onMounted, watch, ref, computed } from '@vue/composition-api';
import { useVolumeKeyDownEvent } from '../player';
import { useBroadCastStream } from '@/common/utils';
export default defineComponent({
    components: {
        KwaiPlayerControlsVolume,
    },
    props: {
        canPreset: {
            type: Boolean,
            default: true,
        },
        volumeKeyDown: {
            type: Boolean,
            default: true,
        },
        initVolumeConfig: {
            type: Object,
            default: () => {
                return {
                    volume: 0.5,
                    setLocal: true,
                    localName: 'visionVolume',
                };
            },
        },
        canChangeVolume: {
            type: Boolean,
            default: true,
        },
        muted: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { root, emit }) {
        const { volume } = useVideoProperties();
        const initialVolume = computed(() => {
            if (typeof props.initVolumeConfig?.volume === 'number') {
                return props.initVolumeConfig?.volume;
            }
            return 0.5;
        });
        const localName = computed(() => props.initVolumeConfig?.localName || 'visionVolume');
        const muteTipShowTime = ref(2000);

        function baseChange(vol: number) {
            if (vol > 1) {
                vol = 1;
            }
            if (vol <= 0.1) {
                vol = 0;
            }
            setTimeout(() => {
                volume.value = vol;
            }, 100);
        }

        function volumeChange(vol: number) {
            if (!props.canChangeVolume) {
                return;
            }
            baseChange(vol);
        }
        function handleVolume(e: KeyboardEvent) {
            if (e.keyCode === 38) {
                volumeChange(volume.value + 0.2);
            } else {
                volumeChange(volume.value - 0.2);
            }
        }
        watch(volume, val => {
            emit('volume-change', val);
            localStorage.setItem(localName.value, String(val));
        });
        watch(() => initialVolume.value, (newVolume: number) => {
            volumeChange(newVolume);
        });
        watch(() => props.muted, val => {
            val && baseChange(0);
        }, {
            immediate: true,
        });
        useBroadCastStream('change-volume', (newVolume: number) => {
            volumeChange(newVolume);
        });
        if (props.volumeKeyDown) {
            useVolumeKeyDownEvent(handleVolume);
        }

        function handleClick(muted: boolean) {
            if (props.canChangeVolume) {
                emit('click-volume', muted);
            }
        }

        function presetVolume() {
            const volumeSettingTime = Number(localStorage.getItem('visionVolumeTime'));
            if (!volumeSettingTime || Number(Date.now()) - volumeSettingTime > 24 * 60 * 60 * 1000) {
                localStorage.setItem('visionVolumeTime', String(Date.now()));
                root.$nextTick(() => {
                    // 如果可以非静音播放，则设置一下音量
                    volumeChange(initialVolume.value);
                });
            } else {
                const curVolume = Number(localStorage.getItem(localName.value)) || initialVolume.value;
                root.$nextTick(() => {
                    // 如果可以非静音播放，则设置一下音量
                    volumeChange(curVolume);
                });
            }
        }

        watch(() => props.canPreset, val => {
            val && presetVolume();
        });

        onMounted(() => {
            if (!props.canPreset) {
                return;
            }
            presetVolume();
        });
        return {
            initialVolume,
            muteTipShowTime,
            handleClick,
        };
    },
});
